import { createContext } from 'react';
import { SchedulerFlowsForExperiments_schedulerFlowsByCompanyId } from 'types/apollo/SchedulerFlowsForExperiments';

export interface OutreachTemplatesContextProps {
  options: SchedulerFlowsForExperiments_schedulerFlowsByCompanyId[];
  /** Live or draining: its leads are being answered, so every variant needs its LLM config. */
  campaignRunning: boolean;
}

export const OutreachTemplatesContext = createContext<OutreachTemplatesContextProps>({
  options: [],
  campaignRunning: false,
});
